// @ts-nocheck

import { css } from 'styled-components';

import { compose } from '../utils';

const suffixWithUnit = (unit) => (x) => (typeof x === 'number' ? `${x}${unit}` : x);
const suffixWithPx = suffixWithUnit('px');
const suffixWithEm = suffixWithUnit('em');
const suffixWithPercent = suffixWithUnit('%');
const convertPixelToEm = (x) => (typeof x === 'number' ? x / 16 : x);
const convertNumberToPercent = (x) => (typeof x === 'number' ? x * 100 : x);

export const toPx = compose(suffixWithPx);
export const toEm = compose(suffixWithEm, convertPixelToEm);
export const toPercent = compose(suffixWithPercent, convertNumberToPercent);

// Media template
const sizes = {
  desktop: 992,
  tablet: 768,
  phone: 376,
};

export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label] / 16}em) {
      ${css(...args)};
    }
  `;

  return acc;
}, {});
